import type { ModelCatalogItem } from '@/api/config'

export type GenerationModelSelectionKind = 'text' | 'image' | 'video'

const STORAGE_KEY = 'videogenerateemp:generation-model-selection:v1'

function readSelectionState(): Record<string, string> {
  if (typeof window === 'undefined') {
    return {}
  }
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) {
      return {}
    }
    const parsed = JSON.parse(raw)
    return parsed && typeof parsed === 'object' ? parsed as Record<string, string> : {}
  } catch {
    return {}
  }
}

function writeSelectionState(state: Record<string, string>) {
  if (typeof window === 'undefined') {
    return
  }
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
}

function buildStorageKey(kind: GenerationModelSelectionKind, operation: string) {
  return `${kind}:${operation}`
}

export function getGenerationModelSelection(kind: GenerationModelSelectionKind, operation: string): string {
  const state = readSelectionState()
  return String(state[buildStorageKey(kind, operation)] || '').trim()
}

export function setGenerationModelSelection(kind: GenerationModelSelectionKind, operation: string, modelId?: string | null) {
  const state = readSelectionState()
  const key = buildStorageKey(kind, operation)
  const normalized = String(modelId || '').trim()
  if (!normalized) {
    delete state[key]
  } else {
    state[key] = normalized
  }
  writeSelectionState(state)
}

export function resolveGenerationModelSelection(
  kind: GenerationModelSelectionKind,
  operation: string,
  options: ModelCatalogItem[]
): string {
  const recent = getGenerationModelSelection(kind, operation)
  if (recent && options.some((item) => item.id === recent)) {
    return recent
  }
  const defaultOption = options.find((item) => item.is_default) || options[0]
  return String(defaultOption?.id || '').trim()
}